import { useEffect, useRef } from 'react';

const TIEMPO_INACTIVIDAD = 10 * 60 * 1000; // 10 minutos

const EVENTOS_ACTIVIDAD = [
  'mousemove',
  'mousedown',
  'keydown',
  'click',
  'scroll',
  'touchstart'
];

export default function useCierrePorInactividad() {
  const timerRef = useRef(null);

  useEffect(() => {
    const cerrarSesion = () => {
      window.localStorage.removeItem('token_seguridad');
      window.localStorage.removeItem('sesionUsuario');

      // Sirve para que otras pestañas también se enteren
      window.localStorage.setItem('logout_inactividad', Date.now().toString());

      window.location.href = '/login';
    };

    const reiniciarTimer = () => {
      const token = window.localStorage.getItem('token_seguridad');

      if (!token) {
        return;
      }

      window.localStorage.setItem('ultima_actividad', Date.now().toString());

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        cerrarSesion();
      }, TIEMPO_INACTIVIDAD);
    };

    const verificarInactividad = () => {
      const token = window.localStorage.getItem('token_seguridad');

      if (!token) {
        return;
      }

      const ultimaActividad = window.localStorage.getItem('ultima_actividad');

      if (!ultimaActividad) {
        reiniciarTimer();
        return;
      }

      const tiempoSinActividad = Date.now() - Number(ultimaActividad);

      if (tiempoSinActividad >= TIEMPO_INACTIVIDAD) {
        cerrarSesion();
      } else {
        reiniciarTimer();
      }
    };

    const sincronizarEntrePestanas = (event) => {
      if (event.key === 'logout_inactividad') {
        window.location.href = '/login';
      }
    };

    EVENTOS_ACTIVIDAD.forEach((evento) => {
      window.addEventListener(evento, reiniciarTimer);
    });

    window.addEventListener('visibilitychange', verificarInactividad);
    window.addEventListener('storage', sincronizarEntrePestanas);

    verificarInactividad();

    return () => {
      EVENTOS_ACTIVIDAD.forEach((evento) => {
        window.removeEventListener(evento, reiniciarTimer);
      });

      window.removeEventListener('visibilitychange', verificarInactividad);
      window.removeEventListener('storage', sincronizarEntrePestanas);

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);
}